import privacyIllustration from "../../images/Privacy & Policy.png";

const Terms = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-privacy-bg to-background">
      <div className="space-y-2 bg-[#EFF7F4] w-full pt-12 pb-12 pl-[115px]">
        <h3 className="text-[#ef8702] text-base font-bold">
          RESOURCES
        </h3>
        <h1 className="text-4xl font-bold text-privacy-header tracking-tight">
          Terms of service
        </h1>
        <p className="text-privacy-muted font-medium">
          Last Updated: June 2025
        </p>
      </div>
      <div className="container mx-auto px-4 py-12 max-w-6xl">
        <div className="grid lg:grid-cols-3 gap-12 items-start">
          {/* Main Content */}
          <div className="lg:col-span-2 space-y-8">
            {/* Introduction */}
            <div className="">
              <p className="text-privacy-text leading-relaxed">
                Welcome to NKENNEAi. At We value your trust and are committed to protecting your
                privacy. This Privacy Policy explains how we collect, use, and safeguard your
                personal information when you use our services.
              </p>
            </div>

            {/* Information We Collect */}
            <section className="space-y-4">
              <h2 className="text-2xl font-semibold text-privacy-header">
                Information We Collect
              </h2>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-accent rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-privacy-text">
                    Personal data (e.g., name, email address, phone number)
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-accent rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-privacy-text">
                    Usage data (e.g., pages visited, time spent)
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-accent rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-privacy-text">
                    Device and browser information
                  </p>
                </div>
              </div>
            </section>

            {/* How We Use Your Information */}
            <section className="space-y-4">
              <h2 className="text-2xl font-semibold text-privacy-header">
                How We Use Your Information
              </h2>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-accent rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-privacy-text">
                    To provide and improve our services
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-accent rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-privacy-text">
                    To personalize your experience
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-accent rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-privacy-text">
                    To communicate with you (e.g., updates, support)
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-accent rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-privacy-text">
                    To ensure safety and prevent abuse
                  </p>
                </div>
              </div>
            </section>

            {/* Data Sharing */}
            <section className="space-y-4">
              <h2 className="text-2xl font-semibold text-privacy-header">
                Data Sharing
              </h2>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-accent rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-privacy-text">
                    We do not sell your data. We may share it with trusted third-party partners to
                    improve our services and provide you with relevant advertisements and content.
                  </p>
                </div>
              </div>
            </section>

            {/* Your Rights */}
            <section className="space-y-4">
              <h2 className="text-2xl font-semibold text-privacy-header">
                Your Rights
              </h2>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-accent rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-privacy-text">
                    Request a copy of your data
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-accent rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-privacy-text">
                    Ask us to delete your data
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-accent rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-privacy-text">
                    Opt out of marketing emails at any time
                  </p>
                </div>
              </div>
            </section>

            {/* Contact Information */}
            <div className="bg-muted rounded-lg p-6 space-y-4">
              <p className="text-privacy-text leading-relaxed">
                At NKE, protecting your privacy is a priority. We collect only the information necessary to deliver and improve our services — such as your name, email
                address, and usage data. We do not sell your personal data, and we are transparent about how we protect and use your information. You always have control — you can access, update, or
                delete your information at any time.
              </p>
              <p className="text-privacy-text leading-relaxed">
                We do not sell your data. We may share your information with trusted partners who help us operate our services (like hosting or analytics
                providers), and only under strict confidentiality agreements. You're always in control — you can request to access, update, or delete your data at
                any time. We store your information securely and follow industry best practices to protect it from unauthorized access.
              </p>
            </div>
          </div>

          {/* Illustration */}
          <div className="lg:col-span-1 flex justify-center">
            <div className="p-8 shadow-sm w-full max-w-md">
              <img
                src={privacyIllustration}
                alt="Privacy and security illustration showing a person with a shield and checkmark"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;